// src/hooks/coinglass/useFearGreedChart.ts

import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { fearGreedChartQueryOptions } from "@/services/queries/coinglass/coinglassQueries";
import type { FearGreedQueryParams } from "@/types/indices";

/**
 * Custom hook for fetching Fear & Greed Index chart data
 *
 * @param params - Optional query parameters (token_id, start_date, end_date, limit)
 * @returns Query result with chart data
 */
export function useFearGreedChart(params?: FearGreedQueryParams) {
  const query = useQuery(fearGreedChartQueryOptions(params));

  useEffect(() => {
    if (query.isLoading) console.log("[Hook] useFearGreedChart loading...");
    if (query.isError) console.error("[Hook] useFearGreedChart error:", query.error);
    if (query.data) console.log("[Hook] useFearGreedChart data received");
  }, [query.isLoading, query.isError, query.data, query.error]);

  return {
    data: query.data?.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
